import { isFullAccess } from "../auth/ProtectedRoutes";

export const ROLES = {
  MANAGER: "a9974ee1-57e7-46e5-b151-f483e42f845d",
  DIRECTOR: "c6b35b33-fa81-49fc-aab6-9cce3b13a88d",
  EMPLOYEE: "33570bc9-6b88-466c-b894-d9b7e8a3ecf6",
  SUPPER_ADMIN: "df636ba9-0f43-44f5-aed0-ee69b15ef7c7",
};

export const PERMISSION = {
  READ: "b2f8c06b-1bff-4252-b1e3-320fe73c3a53",
  CREATE: "4cbc5e38-e7a9-4425-855a-e74e00f647ff",
  UPDATE: "3127d88b-1e79-4637-b928-4de728cfae8c",
  DISABLE: "a9d7d55c-83d2-430d-9e98-a7dc424879aa",
  DELETE: "f08a0789-af1f-434d-b0d3-e201e991b462",
};

export const ACTION = [
  PERMISSION.CREATE,
  PERMISSION.READ,
  PERMISSION.UPDATE,
  PERMISSION.DELETE,
  PERMISSION.DISABLE,
];

export const showAction = (permissions) => {
  return (
    permissions.find((permission) => ACTION.includes(permission.id)) ||
    isFullAccess(permissions)
  );
};

export const allowedShowAction = (permissions, permissionsRoutes) => {
  return (
    allowedToCreateEntity(permissions, permissionsRoutes) ||
    allowedToReadEntity(permissions, permissionsRoutes) ||
    allowedToUpdateEntity(permissions, permissionsRoutes) ||
    allowedToDeleteEntity(permissions, permissionsRoutes)
  );
};

export const allowedToCreateEntity = (permissions, permissionsRoutes) => {
  let permissionIdCreate = "";
  for (const permissionRoute of permissionsRoutes) {
    if (permissionRoute.name.split("-")[0] === "CREATE") {
      permissionIdCreate = permissionRoute.id;
    }
  }
  return (
    permissions.find((permission) => permission.id === permissionIdCreate) ||
    isFullAccess(permissions)
  );
};

export const allowedToReadEntity = (permissions, permissionsRoutes) => {
  let permissionIdCreate = "";
  for (const permissionRoute of permissionsRoutes) {
    if (permissionRoute.name.split("-")[0] === "READ") {
      permissionIdCreate = permissionRoute.id;
    }
  }
  return (
    permissions.find((permission) => permission.id === permissionIdCreate) ||
    isFullAccess(permissions)
  );
};

export const allowedToUpdateEntity = (permissions, permissionsRoutes) => {
  let permissionIdCreate = "";
  for (const permissionRoute of permissionsRoutes) {
    if (permissionRoute.name.split("-")[0] === "UPDATE") {
      permissionIdCreate = permissionRoute.id;
    }
  }

  return (
    permissions.find((permission) => permission.id === permissionIdCreate) ||
    isFullAccess(permissions)
  );
};

export const allowedToDeleteEntity = (permissions, permissionsRoutes) => {
  let permissionIdCreate = "";
  for (const permissionRoute of permissionsRoutes) {
    if (permissionRoute.name.split("-")[0] === "DELETE") {
      permissionIdCreate = permissionRoute.id;
    }
  }
  return (
    permissions.find((permission) => permission.id === permissionIdCreate) ||
    isFullAccess(permissions)
  );
};

export const allowedToResetPass = (permissions) => {
  return isFullAccess(permissions); //==> supper admin
};

export const allowedDeployCache = (
  emailUserCache,
  emailUser,
  currentUserPermission
) => {
  return (
    isSameEmail(emailUserCache, emailUser) ||
    isFullAccess(currentUserPermission)
  );
};

const isSameEmail = (email1, email2) => {
  // Chuẩn hóa các email bằng cách loại bỏ khoảng trắng và chuyển đổi thành chữ thường
  const normalizeEmail = (email) => {
    return email.trim().toLowerCase();
  };

  // Chuẩn hóa hai email
  const normalizedEmail1 = email1 ? normalizeEmail(email1) : email1;
  const normalizedEmail2 = email2 ? normalizeEmail(email2) : email2;

  // So sánh hai email đã được chuẩn hóa
  return normalizedEmail1 === normalizedEmail2;
};
